import cert1 from "./Cert-何明哲-2022仓颉杯-总季军.png";
import cert2 from "./Cert-李宇涵-2022仓颉杯-总亚军.png";
import cert3 from "./Cert-李宇涵-第6届华语朗诵大赛-金奖.png";
import cert4 from "./Cert-极易中文学校-2022仓颉杯-最佳组织奖.png";
import cert5 from "./Cert-王葛覃-2022仓颉杯-总亚军.png";
import cert6 from "./Cert-谢怡龄-第6届华语朗诵大赛-一等奖.png";
import cert7 from "./Cert-高子骞-第6届华语朗诵大赛-一等奖.png";

const certificates = [cert1, cert2, cert3, cert4, cert5, cert6, cert7];
export default certificates;
